import { render, staticRenderFns } from "./YoutubeUpload.vue?vue&type=template&id=2fe8e411&scoped=true"
import script from "./YoutubeUpload.vue?vue&type=script&lang=js"
export * from "./YoutubeUpload.vue?vue&type=script&lang=js"
import style0 from "./YoutubeUpload.vue?vue&type=style&index=0&id=2fe8e411&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe8e411",
  null
  
)

export default component.exports